import { BuildingDto } from "../../../../../../networking/data/responses/building/BuildingDto";

export class Building {
    public readonly address: string;
    public readonly level: number;
    public readonly imageUrl: string;

    public constructor(dto: BuildingDto) {
        if (dto.address == undefined || dto.address == "") {
            throw new Error(`Failed to create Building with address: ${dto.address}.`);
        }
        if (isNaN(dto.level)) {
            throw new Error(`Failed to create Building with level: ${dto.level}.`);
        }
        if (dto.imageUrl == undefined || dto.imageUrl == "") {
            throw new Error(`Failed to create Building with imageUrl: ${dto.imageUrl}.`);
        }
        this.address = dto.address.toUpperCase();
        this.level = dto.level;
        this.imageUrl = dto.imageUrl;
    }
}